"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16PeopleAddFill = function Svg16PeopleAddFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M15.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM21.5 16.5A1.5 1.5 0 0 1 20 18h-.541c.027-.163.041-.33.041-.5-.02-1.185-.454-2.355-1.162-3.3a6.053 6.053 0 0 0-1.167-1.177c1.667.116 2.807.673 3.52 1.49.386.44.59.894.694 1.255 0 0 .115.285.115.732zM16.5 19a1.5 1.5 0 0 0 1.5-1.5c.008-.355-.115-.833-.115-.833-.108-.43-.322-.999-.748-1.567C16.235 13.895 14.616 13 12 13c-2.616 0-4.234.895-5.138 2.1a4.393 4.393 0 0 0-.747 1.567c-.069.276-.098.55-.115.833A1.5 1.5 0 0 0 7.5 19h9zM19.5 9a3 3 0 0 1-3.821 2.886 4.982 4.982 0 0 0 1.32-3.386c0-.909-.242-1.761-.665-2.495A3 3 0 0 1 19.5 9zM5.25 9.25a1 1 0 0 1 1 1V11H7a1 1 0 1 1 0 2h-.75v.75a1 1 0 1 1-2 0V13H3.5a1 1 0 1 1 0-2h.75v-.75a1 1 0 0 1 1-1z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16PeopleAddFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16PeopleAddFill;
exports.default = _default;